import VideoBlogPage from './VideoBlogPage';

export default VideoBlogPage;
